module.exports = __webpack_public_path__ + "static/media/image9.0f35561f.jpg";